const normalizarTexto = (valor = '') => (
  String(valor)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase()
);

export const obterStatusVisualInterno = ({ siglaUnidadeInterno, statusBackend }) => {
  const nomeStatus = typeof statusBackend === 'string'
    ? statusBackend
    : (statusBackend?.name || '');

  const unidadeMoni = normalizarTexto(siglaUnidadeInterno) === 'MONI';
  const statusPreso = normalizarTexto(nomeStatus) === 'PRESO';

  if (unidadeMoni && statusPreso) {
    return 'Monitorado';
  }

  return nomeStatus;
};
